import { TakeAwayProps } from '@/interfaces/models/takeAway';
import { RootState } from '@/store';
import { ActionContext, ActionTree, GetterTree, MutationTree } from 'vuex';

const namespaced: boolean = false;

export interface SocketState {
}

const state: SocketState = {};

const getters: GetterTree<SocketState, RootState> = {};

const actions: ActionTree<SocketState, RootState> = {
  socketCancelTakeAwayOrder({ commit }: ActionContext<SocketState, RootState>, { id }: { id: string }) {
    commit('tv/removeActualOrder', id);
  },
  socketRemoveTakeAwayOrder({ commit }: ActionContext<SocketState, RootState>, { id, isSave }: { id: string, isSave: boolean}) {
    if (!isSave) {
      commit('tv/removeActualOrder', id);
    }
  },
  socketCreateTakeAwayOrder({ commit }: ActionContext<SocketState, RootState>, takeAwayProps: TakeAwayProps) {
    commit('tv/addActualOrder', takeAwayProps);
  },
  socketTakeTakeAwayOrder({ commit }: ActionContext<SocketState, RootState>, takeAwayProps: TakeAwayProps) {
    commit('tv/addActualOrder', takeAwayProps);
  },
  socketRefuseTakeAwayOrder({ rootState, commit }: any, { id }: { id: string }) {
    // commit('tv/removeActualOrder', id);
  },
  socketDoneTakeAwayOrder({ commit }: ActionContext<SocketState, RootState>, { id }: { id: string }) {
    commit('tv/doneActualOrder', id);
  },
  socketUndoneTakeAwayOrder({ commit }: ActionContext<SocketState, RootState>, { id }: { id: string }) {
    commit('tv/undoneActualOrder', id);
  },
  socketIssueOrder({ commit }: ActionContext<SocketState, RootState>, { id }: { id: string }) {
    commit('tv/removeActualOrder', id);
  },
  socketIssueAndPayOrder({ commit }: ActionContext<SocketState, RootState>, { id }: { id: string }) {
    commit('tv/removeActualOrder', id);
  },
};

const mutations: MutationTree<SocketState> = {};

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
